import app from "../../api/app";

export function createSubmit ( credentials ) {
    return app.post( "/login", credentials ).then(
        response => response.data,
        error => Promise.reject( error.response.data )
    );
}
